import { Settings, Bell, Lock, Code } from 'lucide-react'

export default function SettingsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-pawssible-slate-900">Settings</h1>
        <p className="text-pawssible-slate-600 mt-1">Admin configuration and system settings</p>
      </div>

      {/* Admin Profile */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4">Admin Profile</h3>
        <div className="space-y-4">
          <div>
            <label className="label">Email</label>
            <input type="email" defaultValue="admin@pawssible.ai" className="input" />
          </div>
          <div>
            <label className="label">Name</label>
            <input type="text" defaultValue="Admin User" className="input" />
          </div>
          <button className="btn-primary">Update Profile</button>
        </div>
      </div>

      {/* Feature Flags */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4 flex items-center gap-2">
          <Code size={20} /> Feature Flags
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">AI Chat Assistant</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">Find & Connect with Vets</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">Referral Program</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">Care Marketplace</span>
            <input type="checkbox" className="w-5 h-5" />
          </div>
        </div>
      </div>

      {/* Notifications */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4 flex items-center gap-2">
          <Bell size={20} /> Notification Settings
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">New User Registration</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">Support Tickets</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
          <div className="flex items-center justify-between">
            <span className="text-pawssible-slate-900">System Alerts</span>
            <input type="checkbox" defaultChecked className="w-5 h-5" />
          </div>
        </div>
      </div>

      {/* Security */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4 flex items-center gap-2">
          <Lock size={20} /> Security
        </h3>
        <div className="space-y-3">
          <button className="btn-secondary w-full">Change Password</button>
          <button className="btn-secondary w-full">Two-Factor Authentication</button>
          <button className="btn-secondary w-full">View Login History</button>
        </div>
      </div>

      {/* System Status */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4">System Status</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-pawssible-slate-600">API Status</span>
            <span className="text-green-600 font-medium">Operational</span>
          </div>
          <div className="flex justify-between">
            <span className="text-pawssible-slate-600">Database</span>
            <span className="text-green-600 font-medium">Operational</span>
          </div>
          <div className="flex justify-between">
            <span className="text-pawssible-slate-600">Cache (Redis)</span>
            <span className="text-green-600 font-medium">Operational</span>
          </div>
          <div className="flex justify-between">
            <span className="text-pawssible-slate-600">Email Service</span>
            <span className="text-green-600 font-medium">Operational</span>
          </div>
        </div>
      </div>

      {/* Rate Limits */}
      <div className="card">
        <h3 className="text-lg font-semibold text-pawssible-slate-900 mb-4">Rate Limits</h3>
        <div className="space-y-4">
          <div>
            <label className="label">API Requests per Minute (per user)</label>
            <input type="number" defaultValue="100" className="input" />
          </div>
          <div>
            <label className="label">API Requests per Hour (per IP)</label>
            <input type="number" defaultValue="1000" className="input" />
          </div>
          <button className="btn-primary">Update Rate Limits</button>
        </div>
      </div>
    </div>
  )
}
